import { useState } from 'react';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CollectionsIcon from '@mui/icons-material/Collections';
import {
    Avatar,
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Dialog,
    DialogTitle
} from '@mui/material';
import { BentoThemeProvider, colors } from '@zenput/ui-bento';

interface ImageVideoPickerDialogProps {
    onSelect: (option?: string) => Promise<void>;
    title: string;
    translatedStrings?: {
        cameraLabel?: string;
        galleryLabel?: string;
        cancelLabel?: string;
    };
}

export const ImageVideoPickerDialog = (props: ImageVideoPickerDialogProps) => {
    const [open, setOpen] = useState<boolean>(true);
    const { onSelect, title, translatedStrings } = props;

    const handleClose = async () => {
        setOpen(false);
        await onSelect();
    };

    const handleListItemClick = async (option?: string) => {
        setOpen(false);
        await onSelect(option);
    };

    const optionStrings = {
        cameraLabel: 'Camera',
        galleryLabel: 'Gallery',
        cancelLabel: 'Cancel',
        ...translatedStrings
    };

    return (
        <BentoThemeProvider>
            <Dialog onClose={handleClose} open={open}>
                <DialogTitle aria-label="dialog title">{title}</DialogTitle>
                <List sx={{ py: 0, width: 250 }}>
                    <ListItem disableGutters>
                        <ListItemButton aria-label="camera option" onClick={() => handleListItemClick('camera')}>
                            <ListItemAvatar>
                                <Avatar sx={{ bgcolor: colors.blue['50'] }}>
                                    <CameraAltIcon color="primary" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={optionStrings.cameraLabel} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disableGutters>
                        <ListItemButton aria-label="gallery option" onClick={() => handleListItemClick('browse')}>
                            <ListItemAvatar>
                                <Avatar sx={{ bgcolor: colors.blue['50'] }}>
                                    <CollectionsIcon color="primary" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={optionStrings.galleryLabel} sx={{ pr: 1 }} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disableGutters>
                        <ListItemButton onClick={() => handleListItemClick()}>
                            <ListItemText
                                aria-label="close dialog"
                                primary={optionStrings.cancelLabel}
                                sx={{ pr: 1 }}
                                primaryTypographyProps={{ color: 'primary', align: 'center' }}
                            />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Dialog>
        </BentoThemeProvider>
    );
};
